import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Button, Row, Col, Select } from 'antd';

import _ from 'lodash';

import { ENUM_TAGS } from '../../constant/AllBillerDefaultVar';
import text from './FormData.page.translation';

import './FormData.form.style.less';

const { Option } = Select;

class FormData extends Component {
  onValidate = (err, value) => {
    if (!err) {
      this.props.onSubmit(value);
    }
  };

  onCancel = () => {
    this.props.cancelFunction();
  };

  handleSubmit = e => {
    e.preventDefault();
    const {
      form: { validateFields },
    } = this.props;
    validateFields(this.onValidate);
  };

  renderOptions() {
    return ENUM_TAGS.map(tag => (
      <Option value={tag.value} key={tag.id}>
        <span className={`dot ${tag.value.toLowerCase()}`}></span> {tag.value}
      </Option>
    ));
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.formValue.tag_name &&
      prevProps.form.getFieldValue('tag_name') === undefined
    ) {
      this.props.form.setFieldsValue({
        tag_name: '',
      });
    }
  }

  renderForm = () => {
    const {
      form: { getFieldDecorator },
      formValue,
      intl: { formatMessage },
      loading,
    } = this.props;
    return (
      <Form onSubmit={this.handleSubmit}>
        <Row>
          <Col span={24}>
            <Form.Item colon={false} label={formatMessage(text.label.formName)}>
              {getFieldDecorator('name', {
                initialValue: _.get(formValue, 'name', ''),
                rules: [
                  {
                    required: true,
                    message: formatMessage(text.error.input.formName),
                  },
                  {
                    max: 60,
                    message: formatMessage(text.error.input.formNameMax),
                  },
                ],
              })(
                <Input
                  type="text"
                  className="input-form-name"
                  size="large"
                  placeholder={formatMessage(text.placeholder.formName)}
                />,
              )}
            </Form.Item>
            <Form.Item
              colon={false}
              label={formatMessage(text.label.formDescription)}
              className="description-form"
            >
              {getFieldDecorator('description', {
                initialValue: _.get(formValue, 'description', ''),
                rules: [
                  {
                    max: 120,
                    message: formatMessage(text.error.input.formDescription),
                  },
                ],
              })(
                <Input.TextArea
                  className="input-form-description"
                  rows={4}
                  placeholder={formatMessage(text.placeholder.formDescription)}
                />,
              )}
            </Form.Item>
            <Form.Item colon={false} label={formatMessage(text.label.formTags)}>
              {getFieldDecorator('tag_name', {
                initialValue: _.get(formValue, 'tag_name', undefined),
              })(
                <Select
                  placeholder={formatMessage(text.placeholder.formTags)}
                  size="large"
                  className="select-form-tag"
                  allowClear
                >
                  {this.renderOptions()}
                </Select>,
              )}
            </Form.Item>

            <Button type="primary" htmlType="submit" loading={loading}>
              {formatMessage(
                formValue.name ? text.btn.update : text.btn.create,
              )}
            </Button>
            <Button className="ml-15" onClick={this.props.cancelFunction}>
              {formatMessage(text.btn.cancel)}
            </Button>
          </Col>
        </Row>
      </Form>
    );
  };

  render() {
    return <Row>{this.renderForm()}</Row>;
  }
}

FormData.propTypes = {
  intl: PropTypes.object,
  form: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  cancelFunction: PropTypes.func.isRequired,
  formValue: PropTypes.object,
  loading: PropTypes.bool,
};

export default FormData;
